var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_c('div',{staticClass:"text-caption"},[_vm._v("Stationsname")]),_c('div',[_vm._v(_vm._s(_vm.logEntry.payload.stationName))])]),_c('div',[_c('div',{staticClass:"text-caption"},[_vm._v("Lognachricht")]),_c('div',[_vm._v(_vm._s(_vm.logEntry.payload.txt))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }